import React from 'react';
import MUIAlert from '@mui/material/Alert';

export const Alert = props => {
  const { text, bgColor, sx, ...rest } = props;
  return (
    <MUIAlert
      sx={{
        mb: 2,
        ...(bgColor && { backgroundColor: `${bgColor} !important` }),
        ...sx
      }}
      {...rest}
    >
      {text}
    </MUIAlert>
  );
};

export default Alert;
